import React from 'react'
import { Collection } from '@morningtrain/react-resources'
import TableHeader from '../../../ui/table/TableHeader'
import { EnumFilter, PaginationFilter, SearchFilter } from '@morningtrain/react-filters'
import { SelectedDepartmentFilter } from 'support/filters'
import { Translation, Translator, useTranslation } from '@morningtrain/react-translations'
import { Card, PageHeader } from 'ui'
import TranslatedTitle from 'widgets/TranslatedTitle'
import Button from '../../../ui/buttons/Button'
import { Table } from 'widgets/crud'
import * as Columns from 'support/columns'
import AdminPageWithSmartview from 'pages/app/AdminPageWithSmartview'
import MountSmartviewOnClick from 'support/utilities/MountSmartviewOnClick'
import AssignBadgeSmartview from 'widgets/smartviews/settings/AssignBadgeSmartview'
import MountSmartviewOnClickTableRow from 'widgets/crud/MountSmartviewOnClickTableRow'

export default function Badges () {

  const badgeTypePlaceholder = useTranslation('settings.badges.badge_type')

  return (
    <AdminPageWithSmartview>
      <Translator namespace='settings.badges'>

        {/* Page header */}
        <PageHeader title={<TranslatedTitle name='titles.index'/>}>
          <MountSmartviewOnClick smartview={<AssignBadgeSmartview/>}>
            <Button>
              <Translation name='actions.create'/>
            </Button>
          </MountSmartviewOnClick>
        </PageHeader>

        <Card>
          <Collection resourceName='badges.badges'>
            <SelectedDepartmentFilter/>
            <TableHeader>
              <EnumFilter name='badge_type' enum='badges' placeholder={badgeTypePlaceholder}/>
              <SearchFilter/>
            </TableHeader>
            <Table row={<MountSmartviewOnClickTableRow smartview={<AssignBadgeSmartview/>}/>}>
              <Translator namespace='inventory.item.columns'>
                <Columns.Badge
                  name='badge'
                  enum='badges'
                  label={<Translation name='columns.badge.label'/>}
                />
                <Columns.Date
                  name='active_at'
                  label={<Translation name='columns.active_at.label'/>}
                />
                <Columns.Date
                  name='end_at'
                  label={<Translation name='columns.end_at.label'/>}
                />
                <Columns.Text
                  name='user.name'
                  label={<Translation name='columns.username.label'/>}
                />
                <Columns.Date
                  name='updated_at'
                  label={<Translation name='columns.updated_at.label'/>}
                />
              </Translator>
            </Table>
            <PaginationFilter/>
          </Collection>
        </Card>
      </Translator>
    </AdminPageWithSmartview>
  )
}
